import React from "react";
import "../Navigation/css/NavBar.scss";

export default function APIExplorer() {
    return (
        <div>
            API Explorer
        </div>
    )
}